import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import { FaNewspaper } from "react-icons/fa";
import { Dimmer, Divider, Form, Icon, Loader, Popup } from "semantic-ui-react";
import { HtmlRenderer, slugify } from "../../component/utility";
//import SeoHelmet from '../../component/SeoHelmet';

export const BlogList = () => {
    const dataArticle = useLocation().state
    const [article, setArticle] = useState([]);
    const [loadData, setLoadData] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const [currentOffset, setCurrentOffset] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const limit = 9;
    const url = 'https://cms.rudrunner.co.id/api_rudrunner_cms/controler/blog.php';
    const [notFound, setNotFound] = useState(false);

    const navigate = useNavigate();

    const formatData = (data) => {
        return data.map(item => ({
            ...item,
            formatted_time: new Date(item.created_at).toLocaleDateString('en-US', {
                day: 'numeric',
                month: 'long',
                year: 'numeric',
            }),
        }));
    };

    const getArticleData = async (offset = 0, append = false) => {
        if (loadData) return;

        setLoadData(true);
        try {
            const res = await axios.get(url, {
                params: { limit, offset }
            });

            if (res.data.state === 200) {
                const newData = formatData(res.data.data);

                if (newData.length === 0) {
                    setHasMore(false);
                    return;
                }

                setArticle(prev => {
                    const combined = [...prev, ...newData];
                    const unique = combined.filter(
                        (item, index, self) => index === self.findIndex(t => t.id === item.id)
                    );
                    return unique;
                });
                
                setCurrentOffset(offset);
                setNotFound(false);
            } else {
                alert(res.data.message);
                setHasMore(false);
            }
        } finally {
            setLoadData(false);
        }
    };

    const handleLoadMore = () => {
        if (!hasMore || loadData) return;
        const nextOffset = currentOffset + limit;
        getArticleData(nextOffset, true);
    };

    useEffect(() => {
        const handleScroll = () => {
            if (
                window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 50 &&
                !loadData &&
                hasMore
            ) {
                handleLoadMore();
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [loadData, hasMore]);

    const sanitizeInput = (input) => input.replace(/[<>]/g, '').replace(/['"]/g, '').trim();

    const filterArticle = async () => {
        const safeSearch = sanitizeInput(searchValue);

        if (!safeSearch) {
            // Reset ke list normal
            setCurrentOffset(0);
            getArticleData(0, false);
            return;
        }

        setLoadData(true);
        try {
            const res = await axios.get(url, { params: { search: safeSearch } });

            if (res.data.state === 200 && res.data.data.length > 0) {
                setArticle(formatData(res.data.data));
                setNotFound(false);
                setHasMore(false); // Search tidak pakai loadmore
            } else {
                setArticle([]);
                setNotFound(true);
            }
        } finally {
            setLoadData(false);
        }
    };

    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            filterArticle();
        }, 500);

        return () => clearTimeout(delayDebounce);
    }, [searchValue]);

    useEffect(() => {
        document.title = 'Blog';
        window.scrollTo({ top: 0, behavior: 'smooth' });

        // if (article.length === 0) {
        //     getArticleData(0, false);
        // }
    }, []);

    const handleClickArticle = (data) => {
        //const slug = slugify(data.title);
        const slug = data.slug;
        navigate(`/blog/${slug}`, { state: data });
    };

    
    const [paddingTop, setPaddingTop] = useState(0);

    useEffect(() => {
        const updatePadding = () => {
            const topbar =
                document.querySelector(".topbar");

            const navbar =
                document.querySelector(".is-navbar");

            const topbarHeight = topbar?.offsetHeight || 0;
            const navbarHeight = navbar?.offsetHeight || 0;

            setPaddingTop(topbarHeight + navbarHeight);

            //console.log('cek topbar : ' , topbarHeight)
            //console.log('cek navbar : ' , navbarHeight)
        };

        updatePadding();

        window.addEventListener("resize", updatePadding);

        return () => window.removeEventListener("resize", updatePadding);
    }, []);

    return (
        <>
        {/*
            <SeoHelmet
                title={"News & Article | Hoops Indonesia"}
                description={"Simak update terbaru tentang ulasan produk atau berita lainnya mengenai basket di Hoops Indonesia. Baca selengkapnya!"}
            />
                */}
            <section style={{paddingTop: `${paddingTop}px`, backgroundColor: "#f5f5f5"}}>
                <Container>
                    {/* 
                    <Dimmer active={loadData} inverted>
                        <Loader inverted>Loading</Loader>
                    </Dimmer>
                    */}
                    <Row className="mb-2" style={{paddingTop: "3em"}}>
                        <Col md={12} className="text-start">
                            <div className="text-center fs-2"><FaNewspaper /></div>
                            <Divider horizontal><h1 className="fs-5">News & Blog</h1></Divider>
                        </Col>
                    </Row>
                    <Row className="d-flex justify-content-start mb-3">
                        <Col xl={6} lg={6} md={6} sm={12}>
                            <Form onSubmit={filterArticle}>
                                <Form.Group>
                                    <Form.Input
                                        width={10}
                                        placeholder="Search by Title | Description"
                                        value={searchValue}
                                        icon={{ onClick: (e) => filterArticle(), name: "search", link: true }}
                                        onChange={(e) => setSearchValue(e.target.value)}
                                    />
                                </Form.Group>
                            </Form>
                        </Col>
                    </Row>
                    <Row className="d-flex justify-content-start" >
                        {article.map((art, i) => (
                            <Col xl={4} lg={6} md={6} sm={12} key={i} className="mb-4">
                                <div
                                    className="article-card h-100"
                                    onClick={() => handleClickArticle(art)}
                                >
                                    <Image src={art.image_thumbnail} height={200} fluid />
                                    <div style={{padding: "5% 8% 8% 8%"}}>
                                        <div>
                                            <Popup content={art.title} trigger={
                                                <h1 className="fs-5 mb-1 text-truncate">{art.title}</h1>
                                            } />
                                        </div>
                                        <div className="small text-muted mt-1 mb-1">
                                            Date : {art.formatted_time}
                                        </div>
                                        <h2 className="fs-6 fw-light mt-1" >
                                            <HtmlRenderer htmlContent={art.description.slice(0, 150)}/>
                                        </h2>
                                        <div className="small text-muted mt-2" style={{ lineHeight: '0.5em' }}>
                                            Author : {art.author}
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            /*
                            <Col xl={4} lg={6} md={6} sm={12} className="text-start mb-5" key={i}>
                                <Image src={art.image_thumbnail} height={200} rounded fluid />
                                <div>
                                    <Popup content={art.title} trigger={
                                        <h1 className="fs-5 mt-2 mb-1 text-truncate">{art.title}</h1>
                                    } />
                                </div>
                                <div className="small text-muted mt-1 mb-1">Date : {art.formatted_time}</div>
                                <h2 className="fs-6 fw-light mt-1" ><HtmlRenderer htmlContent={art.description.slice(0, 150)}/> ... <span className="btn-link" style={{ cursor: 'pointer' }} onClick={() => handleClickArticle(art)}>read more</span></h2>
                                <div className="small text-muted mt-2" style={{ lineHeight: '0.5em' }}>Author : {art.author}</div>
                            </Col>
                            */
                        ))}
                        {
                            notFound && 
                            <Col xl={12} lg={12} md={12} sm={12} className="text-center mb-5" >
                                <div className="p-5">
                                    <Icon name="exclamation circle" color="orange"/>
                                    <div>Article not found...</div>
                                </div>
                            </Col>
                        }
                    </Row>
                    {
                        hasMore ?
                        
                            <div className="pb-2" style={{ height: "70px", textAlign: "center" }}>
                                {
                                    loadData ?
                                        <Loader active inline size="small" />
                                        :
                                        <Icon name="angle double down" size="big" className="bounce" />
                                }
                            </div>
                            :
                            <div style={{ height: "70px", textAlign: "center" }}>
                                <p>All article has been loaded</p>
                            </div>
                    }
                </Container>
            </section>
        </>
    )
}